import { branchScope, del, get, post } from '@/lib/apiClient';
import { endpoints } from './endpoints';
import type {
  GlobalSettingsInput,
  GlobalSettingsView,
  KeyFormat,
  KeyFormatInput,
  KeyFormatPreview,
  KeyType,
} from '@/models';

const g = endpoints.globalSettings;

// `branchId` null is the organization default layer throughout; a branch is sent
// in X-Branch-Id to the /api/branch/... routes.

/** Resolved settings of the scope, with the source of every field. */
export const getGlobalSettings = (branchId: number | null) =>
  get<GlobalSettingsView>(g.settings(branchId != null), branchScope(branchId));

/** Replaces the fields the scope sets; a field left out inherits again. */
export const saveGlobalSettings = (branchId: number | null, input: GlobalSettingsInput) =>
  post<GlobalSettingsView>(g.settings(branchId != null), input, branchScope(branchId));

/** Every key type with the format that applies to the scope. */
export const listKeyFormats = (branchId: number | null) =>
  get<KeyFormat[]>(g.keyFormats(branchId != null), branchScope(branchId));

/** Creates or updates the scope's format for one key. Uses up no number. */
export const saveKeyFormat = (branchId: number | null, keyType: KeyType, input: KeyFormatInput) =>
  post<KeyFormat>(g.keyFormat(branchId != null, keyType), input, branchScope(branchId));

/** Removes the scope's format, so the key inherits again. */
export const resetKeyFormat = (branchId: number | null, keyType: KeyType) =>
  del<KeyFormat>(g.keyFormat(branchId != null, keyType), branchScope(branchId));

/** Checks an unsaved format and shows what it would generate. Uses up nothing. */
export const previewKeyFormat = (branchId: number | null, keyType: KeyType, format: string) =>
  post<KeyFormatPreview>(g.keyFormatPreview(branchId != null, keyType), { format }, branchScope(branchId));
